import { Component, Input, OnInit } from '@angular/core';
import { IUserAgent } from 'src/app/models/user-agent.model';

@Component({
  selector: 'app-call-user-agent',
  templateUrl: './call-user-agent.component.html',
  styleUrls: ['./call-user-agent.component.scss']
})
export class CallUserAgentComponent implements OnInit {
  @Input() userAgent: IUserAgent;

  constructor() { }

  ngOnInit(): void {
  }

}
